module.exports = __webpack_public_path__ + "static/Service Doc-b836f59118fd61c8e29dd9d857da5cea.svg";